
import { useState } from 'react';

export default function About() {
  const [activeTab, setActiveTab] = useState('mission');

  return (
    <section id="chi-siamo" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Chi Siamo
          </h2>
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Un team di professionisti con esperienza consolidata nel settore delle risorse umane, 
            specializzato in soluzioni HR su misura per aziende di ogni dimensione.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-16">
          <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-white rounded-xl border border-teal-100">
            <div className="text-4xl font-bold text-teal-600 mb-2">20+</div>
            <div className="text-gray-600 font-medium">Anni di Esperienza</div>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-white rounded-xl border border-teal-100">
            <div className="text-4xl font-bold text-teal-600 mb-2">500+</div>
            <div className="text-gray-600 font-medium">Aziende Servite</div>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-white rounded-xl border border-teal-100">
            <div className="text-4xl font-bold text-teal-600 mb-2">100%</div>
            <div className="text-gray-600 font-medium">Orientamento ai Risultati</div>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-white rounded-xl border border-teal-100">
            <div className="text-4xl font-bold text-teal-600 mb-2">Roma</div>
            <div className="text-gray-600 font-medium">Sede Operativa</div>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-8">
          <div className="inline-flex bg-gray-100 rounded-full p-1">
            <button
              onClick={() => setActiveTab('mission')}
              className={`px-8 py-3 rounded-full font-medium transition-all whitespace-nowrap ${
                activeTab === 'mission'
                  ? 'bg-teal-600 text-white shadow-lg'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              La Nostra Mission
            </button>
            <button
              onClick={() => setActiveTab('valori')}
              className={`px-8 py-3 rounded-full font-medium transition-all whitespace-nowrap ${
                activeTab === 'valori'
                  ? 'bg-teal-600 text-white shadow-lg'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              I Nostri Valori
            </button>
            <button
              onClick={() => setActiveTab('team')}
              className={`px-8 py-3 rounded-full font-medium transition-all whitespace-nowrap ${
                activeTab === 'team'
                  ? 'bg-teal-600 text-white shadow-lg'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Il Nostro Team
            </button>
          </div>
        </div>

        {/* Tab Content */}
        <div className="max-w-4xl mx-auto">
          {activeTab === 'mission' && (
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">La Nostra Mission</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                La nostra missione è supportare le aziende nella gestione strategica delle risorse umane, 
                offrendo soluzioni personalizzate che rispondano alle specifiche esigenze di ogni realtà aziendale.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Crediamo che il capitale umano sia il vero motore del successo aziendale. Per questo mettiamo 
                a disposizione la nostra esperienza consolidata per aiutare le imprese a trovare, formare e 
                gestire i migliori talenti, ottimizzando processi e riducendo i costi operativi.
              </p>
            </div>
          )}

          {activeTab === 'valori' && (
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">I Nostri Valori</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-shield-check-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Professionalità</h4>
                    <p className="text-gray-600">
                      Competenza, serietà e attenzione ai dettagli in ogni fase del processo.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-lightbulb-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Innovazione</h4>
                    <p className="text-gray-600">
                      Soluzioni moderne e tecnologicamente avanzate per rispondere alle sfide del mercato.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-heart-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Orientamento al Cliente</h4>
                    <p className="text-gray-600">
                      Il successo dei nostri clienti è il nostro obiettivo principale.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-team-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Collaborazione</h4>
                    <p className="text-gray-600">
                      Lavoriamo fianco a fianco con i nostri clienti per raggiungere risultati concreti.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'team' && (
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Il Nostro Team</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Il nostro team è composto da professionisti con una solida esperienza nel settore delle risorse umane, 
                maturata attraverso anni di collaborazione con importanti realtà aziendali in diversi settori.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Ogni membro del team porta con sé competenze specifiche e una profonda conoscenza delle dinamiche 
                del mercato del lavoro, garantendo un approccio strategico e personalizzato per ogni cliente.
              </p>
              <p className="text-gray-700 leading-relaxed">
                La nostra forza risiede nella capacità di combinare esperienza consolidata, metodologie innovative 
                e un approccio orientato ai risultati, per offrire soluzioni HR di eccellenza che fanno davvero 
                la differenza per le aziende che ci scelgono.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
